import React from "react";
import "date-fns";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import ErrorOutlineRoundedIcon from "@material-ui/icons/ErrorOutlineRounded";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import SparkleIcon from "../../assets/images/sparkleIcon.png";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { weekOffDays, workshiftAssignLabel } from "../../utils/constants/enums";
import { useShiftDst } from "../../utils/useShiftDst";

const useStyles = makeStyles((theme) => ({
  twoRows: {
    background: "#FFFDFA",
    boxShadow: "0px 1px 2px #FBE2C6",
    borderRadius: "8px",
    padding: "20px",
    height: "100%",
    [theme.breakpoints.up("sm")]: {
      gridRow: "span 2",
      border: "1px solid #FDECD9",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
      display: "block",
    },
  },
  container1: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column-reverse",
    },
  },
  slotCountBox: {
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      gap: "20px",
      padding: "0px 5px",
      margin: "0px 5px",
      marginBottom: "16px",
    },
  },
  checkBoxContainer: {},
  checkBoxCard: {
    border: "1px solid #FDECD9",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    padding: "20px",
    marginBottom: "30px",
    minHeight: "160px",
    [theme.breakpoints.down("xs")]: {
      marginBottom: "16px",
    },
    cursor: "pointer",
  },
  cardContent: {
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Roboto",
  },
  red: {
    color: "#E0493E",
    width: "17px",
    height: "17px",
    selfAlign: "center",
    marginLeft: "4px",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "6px",
    },
  },
  content: {
    fontFamily: "Roboto",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#7A7A7A",
    [theme.breakpoints.down("xs")]: {
      fontWeight: "500",
    },
  },
  cardHeading: {
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "18px",
    color: "#3D3D3D",
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    [theme.breakpoints.down("xs")]: {
      fontSize: "14px",
      lineHeight: "16px",
    },
  },
  countBox: {
    background: "#FFF3EB",
    borderRadius: "8px",
    padding: "10px",
    minHeight: "160px",
    marginBottom: "30px",
    marginLeft: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    [theme.breakpoints.down("sm")]: {
      padding: "15px 30px",
      margin: "0px",
      minWidth: "50%",
      minHeight: "110px",
    },
  },
  slotCount: {
    fontWeight: "600",
    fontSize: "28px",
    lineHeight: "32px",
    background: "linear-gradient(180deg, #FFF5EB 100%, #FFF3EB 100%)",
    [theme.breakpoints.down("xs")]: {
      fontSize: "18px",
      lineHeight: "21px",
    },
  },
  padding20: {
    padding: "10px",
    textAlign: "center",
  },
  container2: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    minHeight: "150px",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  shiftAndweekoff: {
    display: "flex",
    flexDirection: "column",
    width: "58%",
    padding: "auto 10px",
    marginRight: "20px",
    justifyContent: "space-evenly",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      width: "100%",
      marginBottom: "16px",
    },
  },
  shiftData: {
    border: "1px solid #FDECD9",
    borderRadius: "8px",
    padding: "16px",
  },
  marginTop8: {
    marginTop: "8px",
    marginBottom: "0px",
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid #FDECD9",
    borderRadius: "8px",
    width: "39%",
    padding: "12px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  actionHeading: {
    fontFamily: "Roboto",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#7A7A7A",
    textAlign: "center",
    marginBottom: "24px",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
      gap: "18px",
    },
  },
  actionBtn: {
    minWidth: "175px",
    minHeight: "40px",
    textTransform: "none",
    fontFamily: "Roboto",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "16px",
    color: "#FF712D",
    border: "1px solid #FF712D",
    [theme.breakpoints.down("xs")]: {
      minWidth: "130px",
    },
  },
  slotEditBtn: {
    width: "15px",
    height: "20px",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  slotActive: {
    background: "#DEF7EA",
    border: "1px solid #DEF7EA",
  },
  topMentor: {
    background: "#F9EFDC",
    color: "#CA8E16",
    padding: "4px 8px",
    maxWidth: "100%",
    lineHeight: "20px",
  },
  viewRbt: {
    color: "#FF712D",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "16px",
    marginTop: "15px",
    cursor: "pointer",
    padding: "8px auto",
  },
  viewSlot: {
    color: "#FF712D",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "16px",
    marginTop: "15px",
    cursor: "pointer",
    padding: "8px auto",
  },
  notChecked: {
    height: "16px",
    width: "16px",
    borderRadius: "50%",
    border: "1px solid #E0E0E0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  checked: {
    color: "#0BAB3E",
  },
  disabled: {
    color: "#E0E0E0",
  },
  hide: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
}));

const SlotActionModel = ({
  setAddSlot,
  showMentorLeaveModal,
  isAutoAddSlotActive,
  autoAddSlotChangeHandler,
  handleOpenModal,
  autoAddSlotPayload,
  slotsCount,
  rbtCount,
  blackListed,
  handleScheduleAction,
  weekOff,
  workShift,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { dst } = useShiftDst();

  const isReactNative = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (
      userAgent.includes("wv") ||
      userAgent.includes("react-native") ||
      window.ReactNativeWebView !== undefined
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className={classes.twoRows}>
      <div className={classes.container1}>
        <div className={classes.checkBoxContainer}>
          <div
            className={
              isAutoAddSlotActive
                ? `${classes.checkBoxCard} ${classes.slotActive}`
                : classes.checkBoxCard
            }
            onClick={() => {
              autoAddSlotChangeHandler();
            }}
          >
            <div>
              <div className={classes.notChecked}>
                {isAutoAddSlotActive === 1 && (
                  <CheckCircleIcon
                    className={`${classes.notChecked} ${classes.checked}`}
                  />
                )}
              </div>
            </div>
            <div className={classes.cardContent}>
              <div className={classes.cardHeading}>
                Auto add slot{" "}
                {isAutoAddSlotActive && slotsCount > 0 ? (
                  <Button
                    className={classes.slotEditBtn}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenModal();
                    }}
                    disabled={!autoAddSlotPayload}
                  >
                    {" "}
                    <CreateOutlinedIcon
                      fontSize="small"
                      style={{ color: "#7A7A7A" }}
                    />
                  </Button>
                ) : (
                  <ErrorOutlineRoundedIcon className={classes.red} />
                )}
              </div>
              <div className={classes.content}>
                {isAutoAddSlotActive && slotsCount >= 0 && slotsCount < 40 ? (
                  <span className={`${classes.topMentor} ${classes.content}`}>
                    <img
                      src={SparkleIcon}
                      alt=""
                      style={{
                        width: "14px",
                        height: "14px",
                        marginRight: "2px",
                      }}
                    />
                    Top mentors create an average of 40 slots each week
                  </span>
                ) : (
                  <>
                    Enable this to auto-add slots in next 7 days for demos and
                    classes
                  </>
                )}{" "}
                <br />
                <br />
                Class slots are only used for rescheduling in assigned batches
                and substitutions
              </div>
            </div>
          </div>
          <div
            className={
              rbtCount > 0
                ? `${classes.checkBoxCard} ${classes.slotActive}`
                : classes.checkBoxCard
            }
            onClick={() => {
              if (blackListed != 1) handleScheduleAction();
            }}
          >
            <div>
              <div className={classes.notChecked}>
                {rbtCount > 0 && (
                  <CheckCircleIcon
                    className={`${classes.notChecked} ${classes.checked}`}
                  />
                )}
              </div>
            </div>
            <div className={classes.cardContent}>
              <div className={classes.cardHeading}>
                Regular schedule{" "}
                {rbtCount == 0 && (
                  <ErrorOutlineRoundedIcon className={classes.red} />
                )}
              </div>
              <div className={classes.content}>
                Regular schedules are used for assigning batches for regular
                classes <br />
                <br />
                {!isReactNative() && rbtCount > 0 ? (
                  <span
                    className={classes.viewRbt}
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push("/classes/free-schedule");
                    }}
                  >
                    View schedule &gt;
                  </span>
                ) : (
                  <>These schedules are auto added for recurring weeks</>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.slotCountBox}>
          <div className={classes.countBox}>
            <div className={classes.slotCount}>
              {slotsCount ? slotsCount : 0}
            </div>
            <div className={`${classes.content} ${classes.padding20}`}>
              Free slots for next 7 days
            </div>
            {!isReactNative() && (
              <span
                className={classes.viewSlot}
                onClick={(e) => {
                  e.stopPropagation();
                  history.push("/demos/viewSlots");
                }}
              >
                View slots &gt;
              </span>
            )}
          </div>
          <div className={classes.countBox}>
            <div className={classes.slotCount}>{rbtCount ? rbtCount : 0}</div>
            <div className={`${classes.content} ${classes.padding20}`}>
              Free Schedules
            </div>
          </div>
        </div>
      </div>
      <div className={classes.container2}>
        <div className={classes.shiftAndweekoff}>
          <div className={classes.shiftData}>
            <div className={classes.content}>Your shift</div>
            <div className={`${classes.cardHeading} ${classes.marginTop8}`}>
              {workshiftAssignLabel(workShift, dst)}
            </div>
          </div>
          <br />
          <div className={classes.shiftData}>
            <div className={classes.content}>Week-off</div>
            <div className={`${classes.cardHeading} ${classes.marginTop8}`}>
              {weekOff == null ? "Not assigned" : weekOffDays[weekOff]}
            </div>
          </div>
        </div>
        <div className={classes.actions}>
          <div className={classes.actionHeading}>Other actions</div>
          <div className={classes.buttonsContainer}>
            <Button
              className={`${classes.actionBtn} ${classes.hide}`}
              onClick={() => setAddSlot(true)}
            >
              Add slots <AddRoundedIcon />
            </Button>
            <br />
            <Button
              className={classes.actionBtn}
              onClick={showMentorLeaveModal}
            >
              Apply Leave
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlotActionModel;
